// extracted by mini-css-extract-plugin
module.exports = {"table":"sudoku_table__2fzPD","row":"sudoku_row__2qd8W","topLine":"sudoku_topLine__1L59w","td":"sudoku_td__3FgJH","leftLine":"sudoku_leftLine__8HDE-"};